<div
  *ngIf="!multipleRadios"
  class="radio-button"
  >

  <input
    type="radio"
    [id]="id"
    [name]="formPathString()"
    [checked]="!!model"
    [value]="value || label"
    [(ngModel)]="model"
    (change)="onChang2($event)"
    [disabled]="control.disabled || parentFormVMDisabled()"
    #nativeEle
  >
  <label
    [ngStyle]="{'font-size.px': fontSize}"
    class="label"
    [ngClass]="{disabled: disabled}"
    (click)="log()"
    [for]="id"
  >
    <strong
      *ngIf="bold"
    >
      {{ bold + ' '}}
    </strong>
      {{ label ?? value }}
    <div *ngIf="required" class="required" [class.valid]="valid"></div>
  </label>

</div>

<div
  *ngIf="multipleRadios"
  [class.max-size]="styleWidth100"
  [class.vertical]="orientation == 'vertical' "
  [class.horizontal]="orientation != 'vertical'"
  class="radio-button container"
  [ngStyle]="{'gap': gap}"
  >
  <div *ngFor="let item of items; let i = index">
    <app-radio-button
      class="item"
      [id]="item + i"
      [name]=" name"
      [control]="control"
      [label]="item"
      [disabled]="disabled"
      [value]="item"
      [selfChecked]="itemsChecked[i]"
      [valid]="valid"
      [control]="control"
      [recursiveChild]="true"
      [required]="required"
      (select)="_multipleSelectHandler($event)"
    ></app-radio-button>
  </div>
</div>
